import React from 'react';
import { CustomPartnerFinish } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/docs-verification-steps/finish/custom-partner';
import type { FinishStepProps } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/docs-verification-steps/finish/types';

import { useFinishStep } from './hooks/use-finish-step';
import { OrganizationFinish } from './organization-finish';
import { FinishStepContainer } from './styles';
import { WidgetFinish } from './widget-finish';

export const FinishStep: React.FC<FinishStepProps> = (props) => {
    const {
        isCustomPartner,
        isInDashboard,
        customPartnerProps,
        widgetFinishProps,
        organizationFinishProps,
    } = useFinishStep(props);

    if (isCustomPartner) {
        return <CustomPartnerFinish {...customPartnerProps} />;
    }

    return (
        <FinishStepContainer>
            {isInDashboard ? (
                <WidgetFinish {...widgetFinishProps} />
            ) : (
                <OrganizationFinish {...organizationFinishProps} />
            )}
        </FinishStepContainer>
    );
};
